export { isActiveMonthlyPlan } from './activeMonthlyPlan'
export { buildRecipient } from './buildRecipient'
export { clsJoin } from './clsJoin'
export { default as lightOrDark } from './color/lightOrDark'
export { toLightThemeColor } from './color/toLightThemeColor'
export { createSwitch } from './createSwitch'
export { isDragMoved } from './drag'
export { getBadgeType } from './getBadgeType'
export { getBlockContent, getBlockContentText } from './getBlockContent'
export { getInlineContext } from './getInlineContext'
export { hasFilledText } from './hasFilledText'
export { isEditorValue } from './isEditorValue'
export { isInsideOverlay } from './isInsideOverlay'
export { isInsideOwnWheel } from './isInsideOwnWheel'
export { isInsidePopover } from './isInsidePopover'
export { isInternalPath } from './isInternalPath'
export { isSubmitHotkey } from './keyboard'
export { isPlainLeftClick } from './mouse'
export { shouldShowWelcome } from './shouldShowWelcome'
export { normalizeString } from './strings'
export { sumEstimateHoursByLineItemId } from './sumEstimateHoursByLineItemId'
export { getBaseTreeType } from './treeLayout'
export const runAsOnClickHandler = (f: () => void) => {
  const button = document.createElement('button')
  button.onclick = f
  button.style.visibility = 'hidden'
  document.body.appendChild(button)
  button.click()
  document.body.removeChild(button)
}
export { getBrowserTimezone } from './getBrowserTimezone'
